import {motion, useReducedMotion} from 'framer-motion';
import {Tooltip} from 'platform/components';
import {Box, Center, Clickable, Show} from 'platform/foundation';

import {useState} from 'react';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {useApplicationUpdate} from '../../Initialize/ApplicationUpdateContext';

const ACTIVATE_KEYS = ['Enter', ' '];
const DOT_SIZE = 3;
const CLICK_TARGET_SIZE = 6;
const HALO_ANIMATION = {scale: [1, 2.2], opacity: [0.7, 0]};
const HALO_TRANSITION = {duration: 1.5, repeat: Infinity, ease: 'easeOut'} as const;

export function UpdateAvailableDot(props: TestIdProps) {
  const {isPatchUpdateAvailable, updateApp} = useApplicationUpdate();
  const [isLoading, setLoading] = useState(false);
  const shouldReduceMotion = useReducedMotion();

  if (!isPatchUpdateAvailable) {
    return null;
  }

  const label = i18n.t('general.checkApplicationVersion.patchAvailableTooltip');
  const handleUpdate = () => {
    if (isLoading) {
      return;
    }
    setLoading(true);
    updateApp().finally(() => setLoading(false));
  };

  return (
    <Box paddingRight={3}>
      <Tooltip label={label} placement="bottom">
        <Clickable
          data-testid={suffixTestId('updateAvailableDot', props)}
          role="button"
          tabIndex={0}
          aria-label={label}
          isDisabled={isLoading}
          width={CLICK_TARGET_SIZE}
          height={CLICK_TARGET_SIZE}
          onClick={handleUpdate}
          onKeyDown={(event) => {
            if (ACTIVATE_KEYS.includes(event.key)) {
              event.preventDefault();
              handleUpdate();
            }
          }}
        >
          <Center width="100%" height="100%">
            <Box position="relative" width={DOT_SIZE} height={DOT_SIZE}>
              <Show when={!shouldReduceMotion}>
                <Box position="absolute" top={0} left={0}>
                  <motion.div animate={HALO_ANIMATION} transition={HALO_TRANSITION}>
                    <Box
                      width={DOT_SIZE}
                      height={DOT_SIZE}
                      borderRadius="circular"
                      backgroundColor="palettes.yellow.70.100"
                    />
                  </motion.div>
                </Box>
              </Show>
              <Box
                position="relative"
                width={DOT_SIZE}
                height={DOT_SIZE}
                borderRadius="circular"
                backgroundColor="palettes.yellow.70.100"
              />
            </Box>
          </Center>
        </Clickable>
      </Tooltip>
    </Box>
  );
}
